import de from "./lang/de";
import en from "./lang/en";
import fr from "./lang/fr";
export default {
  de,
  en,
  fr
};
